const moment = require('moment-timezone');
moment.tz.setDefault("Asia/Tokyo");

const isNumber = function (value) {
    return ((typeof value === 'number') && (isFinite(value)));
};

export function unixtimeToFormattedDate(unixtime) {
    return moment.unix(unixtime).format("YYYY-MM-DD")
}
export function unixtimeToJapaneseShortFormattedDate(unixtime){
    return moment.unix(unixtime).format("YY年MM月DD日")
}
export function unixtimeToFormattedTime(unixtime) {
    if (isNumber(unixtime)) {
        return ("0" + Math.floor(unixtime / 3600)).slice(-2) + ":" + ("0" + Math.floor(unixtime % 3600 / 60)).slice(-2)
    } else {
        return ""
    }
}
export function unixtimeToFormattedLargeTime(unixtime) {
    if (isNumber(unixtime)) {
        return String(Math.floor(unixtime / 3600)) + ":" + ("0" + Math.floor(unixtime % 3600 / 60)).slice(-2)
    } else {
        return ""
    }
}
export function FormattedDateTounixtime(date) {
    return moment(date).unix()
}

export function getUnixtime() {
    return moment().unix()
}
export function unixtimeToFormattedDatetime(unixtime) {
    return moment.unix(unixtime).format("YYYY-MM-DD HH:mm")
}
export function unixtimeToDate(unixtime) {
    return moment.unix(unixtime).toDate()
}
export function differenceInYearsBetweenTodayAnd(unixtime){
    return moment().diff(moment.unix(unixtime),'years')
}
export function getMoment(){
    return moment
}
export function validDateToUnixtime(date){
    return moment(date).unix()
}